export enum enumEntrySummaryState {
  NOT_SENT = 0,
  BROKER_REVIEW_PENDING = 50,
  SENT_TO_PROVIDER = 100,
  BROKER_PROCESSING_PENDING = 120,
  VALIDATED_AT_PROVIDER = 200,
  DUTY_CALCULATION_PENDING = 220,
  DUTY_CALCULATION_COMPLETE = 240,
  BOND_PENDING = 260,
  NOT_VALID_PROVIDER = 300,
  BROKER_PROCESSING_FAILED = 310,
  BROKER_PROCESSING_FINISHING = 330,
  BROKER_PROCESSING_FINISHED = 350,
  AWAITING_ARRIVAL = 380,
  PROVIDER_SEND_PENDING = 400,
  BROKER_PROCESSING_CARGO_RELEASE_PENDING = 420,
  SENT_TO_CBP = 500,
  ACCEPTED = 600,
  NO_BILL_ON_FILE = 655,
  BILL_NOT_MATCHED = 660,
  APPROVED = 700,
  REJECTED = 800,
  CBP_DELETE_PENDING = 900,
  CBP_DELETED = 950,
  DELETED = 1000,
  CUSTOM = 5000,
  UNRECOVERABLE = 10000,
}
